import React from "react";
import { Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";

const ListDataOrganisasiDataCompOpenData = React.memo(({ items, currentPage, totalItems, itemsPerPage, onPageChange, startItem, endItem, formatDate, loading, totalPages }) => {
    
    const modifyUrl = (url) => {
        return url;
    };

    return (
        <section className="d-flex align-items-center">
            <div className="container">
                <div className="row content justify-content-center">
                    <div className="col-md-12">
                        <h4 className="m-b-20" data-aos="fade-left"><i className="bx bx-data"></i> Total <b>{totalItems}</b> Data Organisasi</h4>
                        <br />
                    </div>
                    {
                        loading ? (
                            <div className="col-md-12 text-center" >
                                <h4>Loading Data...</h4>
                            </div>
                        ) :
                            (
                                items.length > 0 ? (
                                    items.map((data, index) => (
                                        <div className="col-md-2 col-sm-4" data-aos="fade-in" key={index}>
                                            <Link to={`/open_data/organisasi/${data.name || 'bps'}`} title={data.title ? data.title : '-'} className="box-news"  state={{ organisasi: data.name || 'bps' }}>
                                                <img src={`${process.env.PUBLIC_URL}/sampang.png`} className="bg-img-absolute" alt="" />
                                                <div className="box-content-news-center" style={{ marginTop: '10px' }}>
                                                    <h3 className="text-center">{data.title ? data.title : '-'}</h3>
                                                    <h3 className="text-center font-weight-700">{data.package_count}</h3>
                                                </div>
                                                <div className="bottom-div text-center">
                                                    <i className="bx bx-time"></i> {formatDate(data.created)}
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-lg-12 box-no-data"> No Data Found</div>
                                )
                            )
                    }
                </div>
            </div>
        </section>
    )
})

export default ListDataOrganisasiDataCompOpenData;